import Api from 'App/api'

export const getCommercial = Api.post({
  controller: 'suite',
  action: 'fetchCommercial',
})

export const getPendingSales = Api.get({
  controller: 'sales_figures',
  action: 'list',
})

export const saveSaleFigure = Api.postMultipart({
  controller: 'sales_figures',
  action: 'save',
})
